/**
 * Indica si una ruta está declarada en el menú (primer nivel o submenus),
 * que es lo que HelpMenuDashboard convierte en <Route>.
 * @param {Array} menu resultado de menus()
 * @param {String} ruta
 */
export function isRutaRegistrada(menu, ruta) {
	if (!Array.isArray(menu)) return false;
	return menu.some((m) =>
		m && (m.to === ruta ||
		(Array.isArray(m.submenus) && m.submenus.some((sm) => sm && sm.to === ruta)))
	);
}
